import React from 'react';
import { th0, dayTh } from '../utils';
import { BG, RW, MONTH_NAMES, DAY_TH_ABBR, getLeftLayout } from '../constants';

const PayrollTableHeader = React.memo(function PayrollTableHeader({
  days,
  dayMeta,
  month,
  year,
  hrMgmt,
  salaryMode = 'late-deduct',
  openBulkDay,
  isMobile = false,
  showUnpaidLeave = false,
}) {
  const { w: LW, left: LEFT } = getLeftLayout(isMobile);
  const incomeColSpan =
    5 +
    (salaryMode !== 'work-time' ? 1 : 0) +
    (salaryMode !== 'late-deduct' ? 1 : 0);
  const deductColSpan = 4 + (salaryMode !== 'work-time' ? 1 : 0) + (showUnpaidLeave ? 1 : 0); // tax + sso + late + crl + other (+ ไม่ได้รับค่าแรง)
  const netColSpan =
    3 +
    (salaryMode !== 'work-time' ? 1 : 0) +
    (salaryMode !== 'late-deduct' ? 1 : 0);

  return (
    <thead>
      {/* ── GROUP HEADER ROW (sticky top:0) ── */}
      <tr>
        <th colSpan={3} style={th0({ position: 'sticky', top: 0, left: isMobile ? undefined : 0, zIndex: 50, background: BG.hInfo, fontSize: '12px' })}>
          ข้อมูลพนักงาน
        </th>
        <th colSpan={days.length} style={th0({ position: 'sticky', top: 0, zIndex: 40, background: BG.hDays, fontSize: '12px' })}>
          การลงเวลา — {MONTH_NAMES[month]} {year}
        </th>
        <th
          colSpan={hrMgmt ? 2 : 1}
          style={th0({ position: 'sticky', top: 0, zIndex: 40, background: BG.hSum, borderRight: hrMgmt ? undefined : 'none', fontSize: '12px' })}
        >
          สรุป
        </th>
        {hrMgmt && (
          <>
            <th colSpan={incomeColSpan} style={th0({ position: 'sticky', top: 0, zIndex: 40, background: BG.hIncome, fontSize: '12px' })}>
              รายได้
            </th>
            <th colSpan={deductColSpan} style={th0({ position: 'sticky', top: 0, zIndex: 40, background: BG.hDeduct, fontSize: '12px' })}>
              หัก
            </th>
            <th colSpan={netColSpan} style={th0({ position: 'sticky', top: 0, zIndex: 40, background: BG.hNet, borderRight: 'none', fontSize: '12px' })}>
              สุทธิ / จัดการ
            </th>
          </>
        )}
      </tr>

      {/* ── COLUMN HEADER ROW (sticky top:34) ── */}
      <tr>
        <th style={th0({ position: 'sticky', top: 34, left: LEFT.no, zIndex: 50, background: BG.cInfo, minWidth: LW.no, width: LW.no, borderBottom: `2px solid ${BG.border}` })}>
          No.
        </th>
        <th style={th0({ position: 'sticky', top: 34, left: LEFT.name, zIndex: 50, background: BG.cInfo, minWidth: LW.name, textAlign: 'left', paddingLeft: isMobile ? 6 : 12, borderBottom: `2px solid ${BG.border}` })}>
          ชื่อ - สกุล
        </th>
        <th style={th0({ position: 'sticky', top: 34, left: LEFT.type, zIndex: 50, background: BG.cInfo, minWidth: LW.type, borderBottom: `2px solid ${BG.border}`, fontSize: '12px' })}>
          <div style={{ borderBottom: `1px solid ${BG.border}`, padding: '4px 2px', marginBottom: 4, fontWeight: 500, color: BG.headerText }}>ปกติ</div>
          <div style={{ color: '#EA580C', fontWeight: 600, padding: '2px 0' }}>OT</div>
        </th>

        {/* day columns */}
        {dayMeta.map(({ day, dow, isToday: td, isHoliday: hd }) => (
          <th
            key={day}
            style={{ ...dayTh(dow, td, hd), cursor: hrMgmt ? 'pointer' : 'default', userSelect: 'none' }}
            title={hrMgmt ? `กำหนดเวลาเข้า-ออกงานให้พนักงานทุกคน วันที่ ${day}/${month + 1}` : undefined}
            onClick={hrMgmt ? () => openBulkDay(day) : undefined}
          >
            <div style={{ fontSize: '11px', color: BG.textMuted, lineHeight: 1.2, marginBottom: 4, letterSpacing: '0.02em' }}>
              {DAY_TH_ABBR[dow]}.
            </div>
            <div style={{ fontSize: '13px', lineHeight: 1.2, fontWeight: 700, color: hd || dow === 0 ? BG.weekendText : BG.headerText }}>
              {day}
            </div>
          </th>
        ))}

        {/* summary columns */}
        <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cSum, minWidth: RW.working, borderBottom: `2px solid ${BG.border}`, fontSize: '12px' })}>
          <div style={{ borderBottom: `1px solid ${BG.border}`, padding: '4px 2px', marginBottom: 4, color: BG.headerText }}>วันทำงาน</div>
          <div style={{ color: '#EA580C', fontSize: '11px', fontWeight: 600 }}>OT ชม.</div>
        </th>

        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cSum, minWidth: RW.dayRate, borderBottom: `2px solid ${BG.border}` })}>
            Day Rate
          </th>
        )}
        {hrMgmt && salaryMode !== 'work-time' && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.salary, borderBottom: `2px solid ${BG.border}` })}>
            ค่าแรง
          </th>
        )}
        {hrMgmt && salaryMode !== 'late-deduct' && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.actualSalary, borderBottom: `2px solid ${BG.border}`, fontSize: '12px' })}>
            <div>ค่าแรง</div>
            <div style={{ fontSize: '11px', fontWeight: 500, color: '#374151' }}>(ชม.จริง)</div>
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.ot, borderBottom: `2px solid ${BG.border}` })}>
            OT
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.allow, borderBottom: `2px solid ${BG.border}` })}>
            เบี้ยเลี้ยง
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.field, borderBottom: `2px solid ${BG.border}` })}>
            ค่าออกสนาม
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.bonus, borderBottom: `2px solid ${BG.border}` })}>
            เงินได้อื่นๆ
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cIncome, minWidth: RW.ssoIncome, borderBottom: `2px solid ${BG.border}` })}>
            ประกันสังคม
          </th>
        )}
        {showUnpaidLeave && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: 100, borderBottom: `2px solid ${BG.border}`, fontSize: '12px' })}>
            <div>ไม่ได้รับ</div>
            <div style={{ fontSize: '11px', fontWeight: 500, color: '#374151' }}>ค่าแรง</div>
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: RW.tax, borderBottom: `2px solid ${BG.border}` })}>
            หักภาษี
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: RW.sso, borderBottom: `2px solid ${BG.border}` })}>
            ประกันสังคม
          </th>
        )}
        {hrMgmt && salaryMode !== 'work-time' && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: RW.late, borderBottom: `2px solid ${BG.border}` })}>
            หักเงินสาย
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: RW.crl, borderBottom: `2px solid ${BG.border}` })}>
            หัก CRL
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cDeduct, minWidth: RW.other, borderBottom: `2px solid ${BG.border}` })}>
            หักอื่นๆ
          </th>
        )}
        {hrMgmt && salaryMode !== 'work-time' && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cNet, minWidth: RW.net, fontWeight: 700, borderBottom: `2px solid ${BG.border}` })}>
            สุทธิ
          </th>
        )}
        {hrMgmt && salaryMode !== 'late-deduct' && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cNet, minWidth: RW.actualNet, borderBottom: `2px solid ${BG.border}`, fontWeight: 700, fontSize: '12px' })}>
            <div>ที่ต้องจ่ายพนักงาน</div>
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cNet, minWidth: RW.companyCost, fontWeight: 700, borderBottom: `2px solid ${BG.border}`, fontSize: '12px' })}>
            <div>ต้นทุนของบริษัท</div>
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cNet, minWidth: RW.note, borderBottom: `2px solid ${BG.border}` })}>
            หมายเหตุ
          </th>
        )}
        {hrMgmt && (
          <th style={th0({ position: 'sticky', top: 34, zIndex: 30, background: BG.cNet, minWidth: RW.manage, borderRight: 'none', borderBottom: `2px solid ${BG.border}` })} />
        )}
      </tr>
    </thead>
  );
});

export default PayrollTableHeader;
